<template>
  <div class="audio-playback" :style="animationSpeed">
    <div class="audio-playback__ldr-box" v-if="props.isLoading" :style="`transform: scale(${props.scale})`">
      <LoaderCircle class="audio-playback__ldr" :color="props.color" />
    </div>
    <PlayIcon 
      class="audio-playback__play"
      :style="`transform: scale(${props.scale}); color: ${props.color}`"
      v-else-if="!props.isPlaying"
    />
    <PauseIcon
      class="audio-playback__pause"
      :style="`transform: scale(${props.scale}); color: ${props.color}`"
      v-else
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  //--------------------------
  import PauseIcon from '../../svg/PauseIcon.vue'
  import PlayIcon from '../../svg/PlayIcon.vue'
  import { LoaderCircle } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //--------------------------
  const props = defineProps({
    //Плеер проигрывается?
    isPlaying: { type: Boolean },
    //Модификатор увеличения кнопок
    scale: { type: Number, default: 1 },
    //Отобразить лоадер вместо иконки?
    isLoading: { type: Boolean },
    //Цвет svg иконок
    color: { type: String },
    //Скорость проигрывания
    speed: { type: Number }
  });
  //Увеличение скорости проигрывания анимации, в зависимости от скорости проигрывания аудио
  const animationSpeed = computed(() => {
    return {'--animation-play-duration': `${1.5 / (props.speed - 0.2)}s`};
  });
</script>

<style scoped lang="scss">
  @import './styles';
</style>

